import './styles.css';
import { KineticBloomGame } from './game';
import { GameUI } from './ui';
import { ViewportService } from './viewport';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Kinetic Bloom could not find its root element.');

const ui = new GameUI(root);
const viewport = new ViewportService(ui.elements.canvas, () => undefined);
const game = new KineticBloomGame(ui, viewport);

void game.initialize();
window.addEventListener('beforeunload', () => game.dispose(), { once: true });
